import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Privacy: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-bg-primary py-24">
      <div className="container-custom max-w-4xl">
        <h1 className="text-4xl font-bold mb-8">{t('privacy.heading')}</h1>
        <p className="text-text-secondary mb-8">{t('privacy.effectiveDate')}</p>

        <div className="prose prose-invert max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-bold mb-4">{t('privacy.intro')}</h2>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">{t('privacy.dataWeCollect.heading')}</h2>
            <p className="text-text-secondary mb-4">{t('privacy.dataWeCollect.intro')}</p>
            <ul className="list-disc pl-6 text-text-secondary">
              <li>{t('privacy.dataWeCollect.li1')}</li>
              <li>{t('privacy.dataWeCollect.li2')}</li>
              <li>{t('privacy.dataWeCollect.li3')}</li>
              <li>{t('privacy.dataWeCollect.li4')}</li>
              <li>{t('privacy.dataWeCollect.li5')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">{t('privacy.howWeUseData.heading')}</h2>
            <p className="text-text-secondary mb-4">{t('privacy.howWeUseData.intro')}</p>
            <ul className="list-disc pl-6 text-text-secondary">
              <li>{t('privacy.howWeUseData.li1')}</li>
              <li>{t('privacy.howWeUseData.li2')}</li>
              <li>{t('privacy.howWeUseData.li3')}</li>
              <li>{t('privacy.howWeUseData.li4')}</li>
              <li>{t('privacy.howWeUseData.li5')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">{t('privacy.legalBasis.heading')}</h2>
            <p className="text-text-secondary mb-4">{t('privacy.legalBasis.intro')}</p>
            <ul className="list-disc pl-6 text-text-secondary">
              <li>{t('privacy.legalBasis.li1')}</li>
              <li>{t('privacy.legalBasis.li2')}</li>
              <li>{t('privacy.legalBasis.li3')}</li>
              <li>{t('privacy.legalBasis.li4')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">{t('privacy.dataSharing.heading')}</h2>
            <p className="text-text-secondary mb-4">{t('privacy.dataSharing.intro')}</p>
            <ul className="list-disc pl-6 text-text-secondary">
              <li>{t('privacy.dataSharing.li1')}</li>
              <li>{t('privacy.dataSharing.li2')}</li>
              <li>{t('privacy.dataSharing.li3')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">{t('privacy.dataRetention.heading')}</h2>
            <p className="text-text-secondary">
              {t('privacy.dataRetention.text')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">{t('privacy.yourRights.heading')}</h2>
            <p className="text-text-secondary mb-4">{t('privacy.yourRights.intro')}</p>
            <ul className="list-disc pl-6 text-text-secondary">
              <li>{t('privacy.yourRights.li1')}</li>
              <li>{t('privacy.yourRights.li2')}</li>
              <li>{t('privacy.yourRights.li3')}</li>
              <li>{t('privacy.yourRights.li4')}</li>
              <li>{t('privacy.yourRights.li5')}</li>
              <li>{t('privacy.yourRights.li6')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">{t('privacy.security.heading')}</h2>
            <p className="text-text-secondary">
              {t('privacy.security.text')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">{t('privacy.internationalTransfers.heading')}</h2>
            <p className="text-text-secondary">
              {t('privacy.internationalTransfers.text')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">{t('privacy.cookies.heading')}</h2>
            <p className="text-text-secondary">
              {t('privacy.cookies.text')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">{t('privacy.contactUs.heading')}</h2>
            <p className="text-text-secondary">
              {t('privacy.contactUs.text')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">{t('privacy.updates.heading')}</h2>
            <p className="text-text-secondary">
              {t('privacy.updates.text')}
            </p>
          </section>

          <div className="mt-12 pt-8 border-t border-white/10">
            <Link to="/" className="btn btn-accent">
              {t('privacy.returnHome')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;